import React, { createContext, useContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const NotificationContext = createContext();

export function useNotification() {
    return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
    const [notifications, setNotifications] = useState([]);

    const showNotification = (message, severity = 'info', duration = 6000) => {
        const newNotification = {
            id: Date.now() + Math.random(),
            message,
            severity,
            duration
        };

        if (notifications.some(n => n.message === message)) {
            return;
        }

        setNotifications(prev => [...prev, newNotification]);
    };

    const handleClose = (notificationId) => {
        setNotifications(prev =>
            prev.filter(notification => notification.id !== notificationId)
        );
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {notifications.map((notification) => (
                <Snackbar
                    key={notification.id}
                    open={true}
                    autoHideDuration={notification.duration}
                    onClose={() => handleClose(notification.id)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert
                        onClose={() => handleClose(notification.id)}
                        severity={notification.severity}
                        sx={{ width: '100%' }}
                    >
                        {notification.message}
                    </Alert>
                </Snackbar>
            ))}
        </NotificationContext.Provider>
    );
} 